import { getAppConfig } from './app-config.js';

/**
 * This is a bit hacky, but seems like a reliable way to determine this
 */ function getTenantSubdomain(hostname = window.location.hostname) {
    return hostname.split('.')[0];
}
/**
 * Gets the K8s namespace for a tenant, taking into account environments where we might be proxying.
 */ function getTenantNamespace() {
    return getAppConfig().tenantNamespace;
}

export { getTenantNamespace, getTenantSubdomain };
//# sourceMappingURL=tenant.js.map
